import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { firstValueFrom, Observable } from 'rxjs';
import { Apollo } from 'apollo-angular';

export class Semaforos {
  public name?: String;
  public operator_00?: String;
  public operator_01?: String;
  public value_00?: Number;
  public value_01?: Number;
  public color?: String[];
  public planningId?: Number;
}

@Injectable({
  providedIn: 'root'
})
export class SemaforoService {
  private apiURL = environment.apiURL_institucion;
  private headers = new HttpHeaders().append('Content-Type', 'application/json')
    .append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  
  constructor(
    private http: HttpClient,
    private cookies: CookieService,
    private apollo: Apollo,
  ) {}

  public getSemaforos(): Observable<any> {
    const apiURL = this.apiURL + "semaforo";
    return this.http.get(`${apiURL}`, { headers: this.headers });
  }
  public postSemaforo(sem: any): Observable<any> {
    const semaf: Semaforos = {
      name: sem.nombre,
      operator_00: sem.operador_00,
      value_00: sem.valor_00,
      value_01: sem.valor_01,
      color: [sem.color],

      planningId: Number(sem.planningId),
    }
    const body = JSON.stringify(semaf);
    const apiURL = this.apiURL + "semaforo";
    return this.http.post(`${apiURL}`, body, { headers: this.headers });
  }
  public patchSemaforo(sem: any): Observable<any> {
    const semaf: Semaforos = {
      name: sem.nombre,
      operator_00: sem.operador_00,
      value_00: sem.valor_00,
      value_01: sem.valor_01,
      color: [sem.color],

      planningId: Number(sem.planningId),
    }
    const body = JSON.stringify(semaf);
    const apiURL = this.apiURL + "semaforo/" + sem.id;
    return this.http.patch(`${apiURL}`, body, { headers: this.headers });
  }
  public deleteSemaforo(sem: any): Observable<any> {
    const apiURL = this.apiURL + "semaforo/" + sem.id;
    return this.http.delete(`${apiURL}`, { headers: this.headers });
  }
}
